import { render, staticRenderFns } from "./AcceptIcon.vue?vue&type=template&id=1e2c2e0c"
import script from "./AcceptIcon.vue?vue&type=script&lang=js"
export * from "./AcceptIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports